import {checkIsNextPath} from 'core/helpers/href-checker';
import React, {ComponentProps, forwardRef, useMemo} from 'react';
import NextLink from 'next/link';
import omit from 'lodash/omit';

type TProps = ComponentProps<typeof NextLink>;

const Link = forwardRef<HTMLAnchorElement, TProps>(function Link(props, ref) {
    const {href, children, ...restLink} = props;

    const hrefString = String(href);

    const isNextRouting = useMemo(() => {
        return checkIsNextPath(hrefString);
    }, [hrefString]);

    if (isNextRouting) {
        return (
            <NextLink href={hrefString} ref={ref} prefetch={false} {...restLink}>
                {children}
            </NextLink>
        );
    }

    const omittedNextLinkProps = ['passHref', 'shallow', 'prefetch'];

    const {passHref, legacyBehavior, prefetch, ...restLinkAttr} = restLink;
    // @ts-expect-error
    if ('a' === children?.type) {
        // @ts-expect-error
        const {key, ref: childrenRef, props: childrenProps} = children;
        const {children: anchorChildren, ...restAnchorProps} = childrenProps;

        return (
            <a
                {...omit(restLinkAttr, omittedNextLinkProps)}
                href={hrefString}
                key={key}
                ref={ref || childrenRef}
                {...restAnchorProps}
            >
                {anchorChildren}
            </a>
        );
    }

    return (
        <a href={hrefString} ref={ref} {...omit(restLink, omittedNextLinkProps)}>
            {children}
        </a>
    );
});

export * from 'next/link';
export default Link;
